import { PermissionRoles } from '../../models/enums/permission-roles';
import { PermissionDetails, Permissions } from '../../models/enums/permissions';
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { HasPermission, } from '../../containers/authorization-helpers/HasPermission';
import { FlatButton } from '../button/FlatButton';
import { DialogHeader } from '../dialog/DialogHeader';
import { DialogTrigger } from '../dialog/DialogTrigger';
import './PermissionsDialog.scss';
// #region Component State

const initialState = {
    open: false,
    overridePermissions: ''
};

type State = (typeof initialState);

// #endregion

/** The numbers in what was typed, separated by commas; anything that is not a number is left out */
const numbersIn = (typed: string): Permissions[] =>
    typed.split(',').map(x => x.trim()).filter(x => /^\d+$/.test(x)).map(Number);

// #region Component Props

interface IProps {
    roles: Permissions[];
    overridePermissions: any;
}

// #endregion

export class PermissionsDialog extends React.Component<IProps, State> {

    public state : State = initialState;
    
    public handleClickOpen = () => {
        this.setState({
            open: true
        });
    }

    public handleClose = () => {
        this.setState({ open: false });
    }

    public render() {
        return <React.Fragment>
            <DialogTrigger
                onClick={this.handleClickOpen}
                buttonClasses="permissiondialog-trigger"
                text="Permissions" />

            <Dialog
                open={this.state.open}
                onClose={this.handleClose}
                maxWidth="md"
                aria-labelledby="form-dialog-title">

                <DialogHeader>
                    <h1>Your Permissions</h1>
                </DialogHeader>

                <DialogContent className="dialog-body-content">
                    <div className="row">
                        <div className="col">
                            <h3>Your Current Permissions:</h3>
                        </div>
                    </div>
                    {
                        this.props.roles && this.props.roles.length > 0
                            ? <div className="permission-scroll">
                                <div className="permission-groups">
                                    {
                                        this.groupsOf(this.props.roles).map(group => (
                                            <div className="permission-group" key={ group.name }>
                                                <h4 className="permission-group-heading">{ group.name }</h4>
                                                {
                                                    group.items.map(item => (
                                                        <div className="permission-item" key={ item }>{ item }</div>
                                                    ))
                                                }
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            : <h3>You have no permissions!  Contact and administrator about getting setup.</h3>
                    }
               
                    <HasPermission requiredPermissions={[
                            Permissions.SupportUsersSave
                        ]}>
                        <div className="override-section" id="override-section">
                            <label>Override Permissions</label>
                            <span>
                                Temporarily change the permissions for your user.  
                                This is used for checking visual permissions only and will
                                not affect your backend permission and access.                                
                            </span>
                            <span>
                                <table className="table">
                                    <tbody>
                                        {
                                            PermissionRoles.map(role => (
                                                <tr key={ role.key }>
                                                    <td>{ role.name }</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-link"
                                                            onClick={ () => this.setState({ overridePermissions: role.permissions.join(',') }) }>
                                                            Use these ({ role.permissions.length })
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                                <span>Or the numbers of permissions, separated by commas, like 34,1.</span>
                            </span>
                            <input 
                                type="text" 
                                className="form-control" 
                                id="permissionOverride" 
                                value={ this.state.overridePermissions } 
                                onChange={ this.onOrderIdChange } />

                            <FlatButton
                                id="overridePermissionBtn"
                                text="Override Me"
                                classes="negative override-button"
                                onBtnClick={
                                    () => this.props.overridePermissions(numbersIn(this.state.overridePermissions))
                                } />
                        </div>
                    </HasPermission>
               
                </DialogContent>
                <DialogActions>
                    <FlatButton
                        id="permissionCloseBtn"
                        text="Close"
                        classes="negative"
                        onBtnClick={this.handleClose} />
                </DialogActions>
            </Dialog>
        </React.Fragment>;
    }

    /**
     * The permissions as the menu shows them, a part of the menu at a time ("Shipping" and its "Trucks > View"). Anything that
     * is not a permission, like what an override was typed as, is listed by itself at the end.
     */
    private groupsOf = (held: Permissions[]): Array<{ name: string; items: string[] }> => {
        const known = held
            .filter(x => PermissionDetails[x] !== undefined)
            .sort((a, b) => a - b);

        const groups: Array<{ name: string; items: string[] }> = [];
        known.forEach(x => {
            const parts = PermissionDetails[x].display.split(' > ');
            const name = parts[0];
            const label = parts.length > 1 ? parts.slice(1).join(' > ') : parts[0];
            const group = groups.find(g => g.name === name);
            if (group) {
                group.items.push(label);
            }
            else {
                groups.push({ name, items: [label] });
            }
        });

        const others = held.filter(x => PermissionDetails[x] === undefined);
        if (others.length > 0) {
            groups.push({ name: 'Other', items: others.map(x => String(x)) });
        }

        return groups;
    }

    private onOrderIdChange = (e: any) => {
        e.preventDefault();

        this.setState({
            overridePermissions: e.target.value
        });
    }
}
